const originalDomain = process.env.NEXT_PUBLIC_ORIGINAL_DOMAIN
const newDomain = process.env.NEXT_PUBLIC_NEW_DOMAIN

export const routes = {
	home: `${originalDomain}/`,
	news: `${newDomain}/news`,
	dashboard: `${newDomain}/dashboard`,
	search: '/search'
}

export const appRoutes = {
	auth: {
		register: {
			provider: {
				accountInformation: '/auth/register/provider/account-information',
				medicalSpecialty: '/auth/register/provider/medical-specialty',
				practiceInformation: '/auth/register/provider/practice-information',
				subscription: '/auth/register/provider/subscription'
			},
			patient: {
				accountInformation: '/auth/register/patient/account-information',
				demographicInformation: '/auth/register/patient/demographic-information',
				insuranceInformation: '/auth/register/patient/insurance-information'
			}
		},
		signIn: {
			patient: '/auth/sign-in/patient',
			provider: '/auth/sign-in/provider',
			teamMember: '/auth/sign-in/team-member',
			verify: '/auth/sign-in/verify',
			forgotPassword: '/auth/sign-in/forgot-password'
		}
	},
	home: '/',
	provider: {
		dashboard: {
			providerProfile: '/provider/dashboard/provider-profile',
			teamMembers: '/provider/dashboard/team-members',
			schedulingTemplate: '/provider/dashboard/scheduling-template',
			appointmentBoard: '/provider/dashboard/appointment-board'
		},
		myAccount: {
			accountInformation: {
				index: '/provider/my-account/account-information',
				profile: {
					name: '/provider/my-account/account-information/profile/name',
					birthday: '/provider/my-account/account-information/profile/birthday',
					gender: '/provider/my-account/account-information/profile/gender'
				},
				contact: {
					phone: '/provider/my-account/account-information/contact/phone',
					email: '/provider/my-account/account-information/contact/email'
				},
				subscription: {
					manage: '/provider/my-account/account-information/subscription/manage',
					creditCard: '/provider/my-account/account-information/subscription/credit-card'
				}
			},
			security: {
				index: '/provider/my-account/security',
				twoStepVerification: '/provider/my-account/security/sign-in/two-step-verification'
			}
		},
		notifications: '/provider/notifications'
	},
	patient: {
		dashboard: {
			appointmentHistory: '/patient/dashboard/appointment-history'
		},
		myAccount: {
			accountInformation: {
				index: '/patient/my-account/account-information',
				profile: {
					name: '/patient/my-account/account-information/profile/name',
					birthday: '/patient/my-account/account-information/profile/birthday',
					gender: '/patient/my-account/account-information/profile/gender'
				},
				contact: {
					address: '/patient/my-account/account-information/contact/address',
					email: '/patient/my-account/account-information/contact/email',
					phone: '/patient/my-account/account-information/contact/phone'
				},
				insuranceInfo: {
					dental: '/patient/my-account/account-information/insurance-information/dental',
					dependent: '/patient/my-account/account-information/insurance-information/dependent',
					medical: '/patient/my-account/account-information/insurance-information/medical',
					vision: '/patient/my-account/account-information/insurance-information/vision'
				}
			},
			security: { index: '/patient/my-account/security' }
		},
		notifications: '/patient/notifications'
	},
	teamMember: {
		dashboard: {
			schedulingTemplate: '/team-member/dashboard/scheduling-template',
			appointmentBoard: '/team-member/dashboard/appointment-board'
		}
	},
	search: {
		index: '/search',
		providerProfile: '/search/provider-profile'
	},
	about: '/about',
	contactUs: '/contact-us',
	news: '/news',
	terms: {
		termsOfUse: '/terms/terms-of-use',
		privacyPolicy: '/terms/privacy-policy',
		acceptableUsePolicy: '/terms/acceptable-use-policy',
		additionalTerms: '/terms/additional-terms'
	}
}
